import React, { Component } from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import track from "react-tracking";
class ThankYouRefer extends Component {
    /* --- React Lifecycle Methods --- */
    /**
     * React lifecycle method
     *
     * @method render
     * @private
     * @returns {HTMLElement} Component element
     */
    render() {
        return (<div className="content content_bufferTopLg mix-content_centerText">
				<div className="wrapper wrapper_narrow">
					<div className="vr vr_x10">
						<h2 className="hdg js-pageHeader">
							<FormattedMessage id="thankYouRefer.header" defaultMessage="Thank You!"/>
						</h2>
					</div>
					<div className="vr vr_x4">
						<div className="text">
							<FormattedMessage tagName="p" id="thankYouRefer.message" defaultMessage="Thank you for your assistance. You may close this window."/>
						</div>
					</div>
				</div>
			</div>);
    }
}
/* --- React Redux bootstrapping --- */
/* Create and export container component that wraps ThankYouRefer for property binding */
export default track({ page: "ThankYouRefer" }, { dispatchOnMount: true })(connect()(ThankYouRefer));



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/public/ThankYouRefer.tsx